import React from 'react';
// import PropTypes from 'prop-types';

import { PageWrapper, ContentWrapper } from '../../../../dronebee-ui';

const config = programConfig;

const Resources = () => {
  const headerText = 'Helpful Links';

  return (
    <PageWrapper>
      <ContentWrapper
        headerDesc={<p className='fw-bold mb-0'>{config.programName}</p>}
        header={headerText}
      >
        <div dangerouslySetInnerHTML={{ __html: config.staticPages.resources.content }} />
      </ContentWrapper>
    </PageWrapper>
  );
};

Resources.propTypes = {
};

export default Resources;
